export default "__VITE_ASSET__DC3RxxVk__"